import SettingsStore from './SettingsStore';
import settingsClient from '../../client/settingsClient';
import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';

function syncSettingsWithEditor(
  settingsStore: SettingsStore,
  deviceType: TPADeviceType,
) {
  return settingsClient.subscribe((settings) => {
    if (!settings) {
      console.warn('empty settings from setting client');
      return;
    }

    settingsStore.set(settings);
  }, deviceType);
}

export default syncSettingsWithEditor;
